import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { LookupApiFacade } from "./lookup.api-facade";
import { LookupStoreFacade } from "./lookup.store-facade";
import { Lookup } from "./lookup.model";

export class LookupFacade extends  RestrictedAccountObjectFacade<Lookup, LookupApiFacade, LookupStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.facade.ts